import PessoaDTO from "./PessoaDTO";

export default class MedicoDTO extends PessoaDTO {
    crm = '';
}

